{
  "error.cookie_needed.description": "您的浏览器设置为阻止Cookie和本地存储。\n请允许浏览器首选项中的Cookie访问Experience Cloud。",
  "error.cookie_needed.heading": "阻止Cookie",
  "error.cookie_needed.refreshBtn": "刷新",
  "error.not_found.description": "此页面不可用。请尝试检查 URL 或访问其他页面。",
  "error.not_found.heading": "错误 404: 页面未找到",
  "error.offline.description": "检查您的Internet连接并刷新页面",
  "error.offline.heading": "无Internet连接",
  "error.rate_limit.description": "我们遇到了流量过高问题。请重新加载页面或在几分钟后重试。\n如果您仍收到此消息，请联系客户关怀和参考以下内容:\nEIM 实例 ID {instanceId}",
  "error.rate_limit.heading": "错误 429: 比率限制",
  "error.rate_limit.refreshBtn": "刷新",
  "error.timeout.description": "此页面无法加载。请尝试刷新或访问其他页面。\n如果您仍收到此消息，请联系客户关怀和参考以下内容:\nEIM 实例 ID {instanceId}",
  "error.timeout.heading": "错误 408: 请求超时",
  "error.timeout.refreshBtn": "刷新",
  "error.unknown.description": "页面未正确加载。请检查您的登录信息，然后重试。\n如果您仍收到此消息，请联系客户关怀和参考以下内容:\nEIM 实例 ID {instanceId}",
  "error.unknown.heading": "无法加载页面",
  "error.unknown.refreshBtn": "刷新"
}
